import { Pipe, PipeTransform } from '@angular/core';
import { isNullOrUndefined } from 'util';

@Pipe({
  name: 'printEmpty'
})
export class PrintEmptyPipe implements PipeTransform {
  transform(value: any, additionalValues?: any[], emptySign = '-'): any {
    let isEmpty;
    if (additionalValues) {
      isEmpty = additionalValues.includes(value);
    } else {
      isEmpty = isNullOrUndefined(value) || value === '';
    }
    return isEmpty ? emptySign : value;
  }
}
